import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Task, TaskCategory, TaskGroup } from "@/store/tasks/types";
import { DispatchRequest } from "@/store/mobile/types";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";

const Mobile = namespace("mobile");
const Tasks = namespace("tasks");
const GuardTours = namespace("GuardTours");

@Component({})
export default class GuardTourMixin extends Vue {

    @GuardTours.Getter getGuardTour: (guardTourId: number) => GuardTour;
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Tasks.Getter("getTasks") tasks: Task[];

    public get currentTourStep(): GuardTourStep {
		const currentGuardTour = this.getGuardTour(this.activeDispatchRequest.guardTourId);
		if (currentGuardTour && currentGuardTour.guardTourSteps) {
			const currentStep = currentGuardTour.guardTourSteps.find(
				(g: GuardTourStep) => g.guardTourStepId == this.activeDispatchRequest.objectId
			);
			return currentStep;
		}

		return null;
	}

	public get tourStepHasActions(): boolean {
		if (!this.currentTourStep) {
			return false;
		}

		const stepHasActions = this.currentTourStep && this.currentTourStep.scriptId && this.currentTourStep.scriptId > 0;
		return stepHasActions;
	}

	public get numberOfTourStepsRemaining(): number {
		const tour = this.getGuardTour(this.activeDispatchRequest.guardTourId);
		if (tour && tour.guardTourSteps) {
			return tour.guardTourSteps.length - this.currentTourStep.stepOrder;
		}
		return 0;
	}

	public get tasksForStep() : Task[] {
		if (!this.currentTourStep || !this.tasks) {
			return [];
		}

		const guardTourStepId = this.currentTourStep.guardTourStepId;
		const filteredTasks = this.tasks.filter(x => x.guardTourStepId === guardTourStepId);
		return filteredTasks;
	}

	public get requiredTasksComplete() {
		return this.tasksForStep ? this.tasksForStep.filter(t => t.required).every(t => t.completed) : true;
	}
}